/*=========================================================================================
  File Name: captions.js
  Description: Helpers for self-hosted video captions (WCAG SC 1.2.2) and transcripts
               (SC 1.2.3).

               Every self-hosted MP4 in object storage has (or can have) a WebVTT file
               beside it with the same name: `content/x/y.mp4` -> `content/x/y.vtt`. The
               players derive that URL from the video URL, so adding captions to a video
               is only an upload - no code change per video.
==========================================================================================*/

/**
 * The caption file that sits beside a self-hosted MP4, or '' for anything else (YouTube
 * embeds, images, PDFs).
 *
 * @param {string} src
 * @returns {string}
 */
export function captionsUrlFor(src) {
  if (typeof src !== 'string') return '';
  const match = src.match(/^([^?#]*)\.mp4(?:[?#].*)?$/i);
  return match ? `${match[1]}.vtt` : '';
}

/**
 * A plain-text transcript built from a loaded text track, so a video with captions also
 * has a media alternative without a second file being uploaded.
 *
 * @param {TextTrackCueList|ArrayLike<{text: string}>} cues
 * @returns {string}
 */
export function transcriptFromCues(cues) {
  if (!cues || !cues.length) return '';
  const parts = [];
  for (let i = 0; i < cues.length; i += 1) {
    const text = String(cues[i].text || '')
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    // Non-speech cues repeat ([Music] x 10); keep the first of a run only.
    if (text && parts[parts.length - 1] !== text) parts.push(text);
  }
  return parts.join(' ');
}
